import React from 'react';
import './Loader.css';

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="spinner"></div>
        <p>Consultando infracciones...</p>
        <small>Esto puede tomar hasta 30 segundos por jurisdicción</small>
      </div>
    </div>
  );
}

export default Loader;
